import { Inlines } from '../Inlines';

export default function HeadingBlock({ block, headingOffset = 0 }) {
  const level = Math.min(6, Math.max(1, (block.level || 2) + headingOffset));
  const Tag = `h${level}`;
  return (
    <Tag id={block.id} className="content-heading">
      <Inlines nodes={block.children} />
      {block.id && (
        <a className="heading-anchor" href={`#${block.id}`} aria-label="Link to this section">#</a>
      )}
    </Tag>
  );
}
